import { render, staticRenderFns } from "./SessionLogo.vue?vue&type=template&id=a8611cf4"
import script from "./SessionLogo.vue?vue&type=script&lang=js"
export * from "./SessionLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports